module.exports = __webpack_public_path__ + "static/media/linkedin_black.d7879285.svg";